import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import TLLcards from "./TLLcards";
import {
  currentMonthName,
  currentMonthNumber,
  currentYear,
} from "../../common-data/Converts";
import FiltersTrainerDetails from "./common/FiltersTrainerDetails";
import "../../../styles/pt/trainer-details.css";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../../data/APIs";
import { fetchPTTrainersData } from "../../../redux/reducers/apiSlice";
import TrainerDetailsCard from "./common/TrainerDetailsCard";
import { selectAuth } from "../../auth/auth.selector";
import { isManagerRole as checkIsManagerRole } from "../../common-data/Conversions";

const TrainerDetailsPage = ({
  trainerDetailsInfo,
  newQueryParametersForAll,
  decryptedText,
}) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const { user } = userInfo || {};
  const isAdmin = user?.account_type === "admin";
  const isManagerRole = checkIsManagerRole(user);
  const gymData = useSelector(selectGymData);
  const { allPTTrainersData } = useSelector((state) => state.api);
  const [trainersData, setAllTrainersData] = useState([]);

  const {
    gym_name,
    gym_id,
    trainer_name = trainerDetailsInfo?.trainer_name || trainerDetailsInfo?.name,
    trainer_id = trainerDetailsInfo?.trainer_id || trainerDetailsInfo?.user_id,
  } = trainerDetailsInfo || {};

  const getParameterValue = (parameterName, queryString) => {
    const regex = new RegExp(`[?&]${parameterName}=([^&]*)`);
    const match = regex.exec(queryString);
    return match ? decodeURIComponent(match[1]) : null;
  };
  const gymFromQPs = getParameterValue("gym_id", newQueryParametersForAll);
  const trainerFromQPs = getParameterValue(
    "trainer_id",
    newQueryParametersForAll
  );

  const findGymName = gymFromQPs
    ? gymData?.find((gym) => gym.value === gymFromQPs)?.label
    : "";
  const findTrainerName = trainerFromQPs
    ? trainersData?.find((trainer) => trainer.value === trainer)?.label
    : "";

  const iniTDFilters = {
    selectedGym: !isAdmin && !isManagerRole
      ? `&gym_id=${
          decryptedText?.gym_id || decryptedText?.uid || decryptedText?.user_id
        }`
      : (gym_id || gymFromQPs) && (gym_name || findGymName)
      ? { label: gym_name || findGymName, value: gym_id || gymFromQPs }
      : "",
    selectedTrainer:
      trainer_id || findTrainerName || trainer_name || findGymName
        ? {
            label: trainer_name || findTrainerName,
            value: trainer_id || findTrainerName,
          }
        : "",
    selectedMonth: {
      label: currentMonthName,
      value: currentMonthNumber,
    },
    selectedYear: {
      label: currentYear,
      value: currentYear,
    },
  };
  const [tdFilters, setTdFilters] = useState(iniTDFilters);
  const [sendableQPs, setSendableQPs] = useState("");

  const onClickReset = () => {
    setTdFilters(iniTDFilters);
    setSendableQPs("");
  };

  useEffect(() => {
    setTdFilters((prevs) => ({
      ...prevs,
      selectedGym: !isAdmin && !isManagerRole
        ? `&gym_id=${
            decryptedText?.gym_id ||
            decryptedText?.uid ||
            decryptedText?.user_id
          }`
        : (gym_id || gymFromQPs) && (gym_name || findGymName)
        ? { label: gym_name || findGymName, value: gym_id || gymFromQPs }
        : "",
    }));
  }, [decryptedText?.gym_id]);

  useEffect(() => {
    const monthQP = tdFilters.selectedMonth?.value
      ? `&month=${tdFilters.selectedMonth.value}`
      : "";
    const yearQP = tdFilters.selectedYear?.value
      ? `&year=${tdFilters.selectedYear.value}`
      : "";
    const gymQP = tdFilters.selectedGym?.value
      ? `&gym_id=${tdFilters.selectedGym.value}`
      : "";
    const trainerQP = tdFilters.selectedTrainer?.value
      ? `&trainer_id=${tdFilters.selectedTrainer.value}`
      : "";
    const sendableQUeryParam = `${monthQP}${yearQP}${gymQP}${trainerQP}`;
    setSendableQPs(sendableQUeryParam);
  }, [tdFilters]);

  useEffect(() => {
    dispatch(fetchGymData(decryptedText?.token));
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      fetchPTTrainersData({
        gymId: tdFilters.selectedGym?.value ? tdFilters.selectedGym.value : "",
        token: decryptedText?.token,
      })
    );
  }, [tdFilters.selectedGym?.value]);

  useEffect(() => {
    if (allPTTrainersData?.status && allPTTrainersData?.data?.length > 0) {
      const trainers = allPTTrainersData.data?.map((item) => ({
        value: item.user_id,
        label: item.name,
      }));
      setAllTrainersData(trainers);
    } else {
      setAllTrainersData([]);
    }
  }, [allPTTrainersData]);

  return (
    <div>
      <Container fluid>
        <Row>
          <Col>
            <FiltersTrainerDetails
              name={"trainer-details"}
              filters={tdFilters}
              setFilters={setTdFilters}
              onClickReset={onClickReset}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <TrainerDetailsCard sendableQPs={sendableQPs} />
          </Col>
        </Row>
        {/* <Row>
          <Col>
            <TMTAcards
              sendableQPs={sendableQPs}
              decryptedText={decryptedText}
              queryParametersForAll={newQueryParametersForAll}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <ORPLcards
              filters={tdFilters}
              sendableQPs={sendableQPs}
              decryptedText={decryptedText}
              queryParametersForAll={newQueryParametersForAll}
            />
          </Col>
        </Row> */}
        <Row>
          <Col>
            <TLLcards
              filters={tdFilters}
              sendableQPs={sendableQPs}
              decryptedText={decryptedText}
              queryParametersForAll={newQueryParametersForAll}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TrainerDetailsPage;
